module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head",
    attrs: {
      "id": "fm02-001"
    }
  }, [_c('b', [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("A very special thank-you to everyone who helped with "), _c('i', [_vm._v("Folksy Friends")]), _vm._v(": Nicole Buckley, Nicole Calver, Amanda Castor, Ben Darby, Erin Davis, Allison Dutton, Joshua Helms (also known as Molli Sparkles), Anneliese Johnson, Amanda Kattner, Adrianne Reid, Alison Robins, Sarah Schraw, Nicole Shipley, Anne Sullivan, Angie Wilson, and Kristy and Shayla Wolf.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("My sincere thanks to my fellow plant lady, Heather Givans. Thanks also to the wonderful longarm quilters who quilted tops for the book—Rachael Dorr, Marion McClellan, Andrea Munro, Karlee Porter, Kathleen Riggins, and Angela Walters—without you, I’m just a piece-maker. I owe my gratitude to all the individuals and companies that contributed fabric and notions for the book: Alison Glass and Andover Fabrics, Inc.; my favorite local quilt shop—Crimson Tate (and the CT crew!); Daylight Company; Me+You (and Aaron, too!); Oakshott Fabrics; Paper Pieces; Robert Kaufman Fabrics; Windham Fabrics; and Quilters Dream Batting.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Finally, thank you to my amazingly understanding team at C&T Publishing. You all "), _c('i', [_vm._v("rock")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84a862d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_acknowledgement.vue
// module id = 66
// module chunks = 0